export default __webpack_public_path__ + "e4bf1f45c18ccf20f8f5377fc2bc29b4.svg";